import { Splide, SplideSlide } from "@splidejs/react-splide";
import moment from "moment-jalaali";
import { localizeNumbers } from "../../../functions";
import AppLink from "../../router/app-link";
import Col from "../../tailwind/col";
import Slider from "./slider";

export interface IServiceSliderProps {
  timeOfService: { total: number; remind: number };
  constraints: {
    title: string;
    postfix: string;
    total: number;
    remind: number;
    expireDate?: Date;
  }[];
  isNgnService: boolean;
  ngnTellNumber: string;
}

export default function ServiceSlider({
  timeOfService,
  constraints,
  isNgnService,
}: IServiceSliderProps) {
  let totalSlide = 1 + constraints.length;
  // console.log("isNgnService", isNgnService);

  return (
    <Col className="col-xs-12 col-sm-6 mb-3 mb-sm-0">
      <div className="bcard" dir="ltr">
        <Splide
          onMove={(splide, newIndex) => {
            if (newIndex === 0) splide.Components.Controller.go(1);
            if (newIndex > totalSlide)
              splide.Components.Controller.go(totalSlide);
          }}
          options={{
            focus: "center",
            start: 2,
            perPage: 3,
            gap: "10px",
            updateOnMove: true,
            pagination: false,
            breakpoints: {
              768: {
                perPage: 2.2,
                start: 2.5,
              },
            },
          }}
        >
          <SplideSlide />
          <Slider
            total={timeOfService.total}
            isNgnService={isNgnService}
            remind={timeOfService.remind}
            backgroundColor={["#1279cd", "#e3e5ea"]}
            title="زمان باقیمانده"
            innerText={localizeNumbers(`${timeOfService.remind}روز`)}
          />
          {constraints.map((c) =>
            !c.expireDate ? (
              <>
                <Slider
                  total={c.total}
                  isNgnService={isNgnService}
                  remind={c.remind}
                  postfix={c.postfix}
                  backgroundColor={["#d52727", "#e3e5ea"]}
                  title={c.title}
                  innerText={localizeNumbers(
                    `${Math.round(c.remind)} ${c.postfix}`
                  )}
                  footer={
                    isNgnService ? (
                      <AppLink
                        id="usageDetails"
                        to="/ngnUsages"
                        className="text-blue-d2 position-bc pb-2 pt-4"
                      >
                        <small>
                          <i className="far fa-hand-point-left"></i>
                          جزییات مصرف
                        </small>
                      </AppLink>
                    ) : (
                      <AppLink
                        id="usageDetails"
                        to="/usages"
                        className="text-blue-d2 position-bc pb-2 pt-4"
                      >
                        <small>
                          <i className="far fa-hand-point-left"></i>
                          جزییات مصرف
                        </small>
                      </AppLink>
                    )
                  }
                />
              </>
            ) : (
              <Slider
                total={c.total}
                isNgnService={isNgnService}
                remind={c.remind}
                backgroundColor={["#89c26b", "#e3e5ea"]}
                title={c.title}
                innerText={localizeNumbers(
                  `${Math.round(c.remind)} ${c.postfix}`
                )}
                footer={
                  <small className="position-bc  pb-2 pt-4">
                    <i className="far fa-clock"></i>
                    {getRemindDays(c.expireDate)} روز
                  </small>
                }
              />
            )
          )}
          <SplideSlide />
        </Splide>
      </div>
    </Col>
  );
}

function getRemindDays(expireDate: Date) {
  return localizeNumbers(moment(expireDate).diff(moment(), "days").toString());
}
